import adminReducer from "@/components/email/admin/ducks/reducer"
import userReducer from "@/components/email/ducks/reducer"
import volunteerReducer from "@/components/email/volunteer/ducks/reducer"
import { combineReducers } from "@reduxjs/toolkit"

const emailReducer = combineReducers({
  admin: adminReducer,
  user: userReducer,
  volunteer: volunteerReducer,
})

export default emailReducer
